/**
 * A hook to slide carousel container to make target visible
 * @param container container to be scrolled
 * @param target target to be visible
 * @returns scroll left for the container
 */
export function scrollCarouselItemToBeVisible(
  container: Element,
  target: Element,
  { offset = 0, behavior }: { offset?: number; behavior?: ScrollBehavior } = {},
) {
  const { left: containerLeft, right: containerRight } = container.getBoundingClientRect();
  const { left: targetLeft, right: targetRight } = target.getBoundingClientRect();

  const { scrollLeft } = container;

  if (targetLeft >= containerLeft && targetRight <= containerRight) return scrollLeft;

  let left = 0;

  if (targetLeft < containerLeft) {
    left = targetLeft - containerLeft - offset;
  } else if (targetRight > containerRight) {
    left = targetRight - containerRight + offset;
  }

  container.scrollBy({ left, behavior });

  return scrollLeft + left;
}
